import type { CurrencyCodeType } from '@shared/utils/currency/currency.types';

// Subset shown at the top of the currency picker for quick access.
export const TRAVEL_DEFAULT_CURRENCY_CODES: ReadonlyArray<CurrencyCodeType> = ['AUD', 'CAD', 'EUR', 'GBP', 'JPY', 'USD', 'NZD'];
